import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";
import type { Batch } from "./batchesApi";
import type { Supplier } from "./suppliersApi";
import type { SeedBatchDto } from "@/features/production/services/seedBatchApi";

// ── Approval payloads (SPEC_DEMO2FEEDBACK_STOCK_INPUTS_OVERHAUL §e/§j/#25) ──
// Three flows, one shape: pass `isApproved: false` plus a non-empty `rejectionReason`
// to reject. The service-layer rejects the call without it.

export interface SupplierApprovalRequest {
  isApproved: boolean;
  rejectionReason?: string;
}

export interface InputBatchApprovalRequest {
  isApproved: boolean;
  rejectionReason?: string;
}

export interface SeedBatchApprovalRequest {
  isApproved: boolean;
  rejectionReason?: string;
}

export const approvalsApi = {
  // Suppliers — GM queue (#25)
  getPendingSuppliers: async (): Promise<Supplier[]> => {
    const { data } = await apiClient.get<ApiResponse<Supplier[]>>(
      "/Suppliers/pending"
    );
    return data.data;
  },
  approveSupplier: async (
    id: string,
    request: SupplierApprovalRequest
  ): Promise<Supplier> => {
    const { data } = await apiClient.post<ApiResponse<Supplier>>(
      `/Suppliers/${id}/approve`,
      request
    );
    return data.data;
  },

  // Stock receipts (InputBatch) — GM queue (§e)
  getPendingStockReceipts: async (): Promise<Batch[]> => {
    const { data } = await apiClient.get<ApiResponse<Batch[]>>(
      "/Stock/receipts/pending"
    );
    return data.data;
  },
  approveStockReceipt: async (
    id: string,
    request: InputBatchApprovalRequest
  ): Promise<Batch> => {
    const { data } = await apiClient.post<ApiResponse<Batch>>(
      `/Stock/receipts/${id}/approve`,
      request
    );
    return data.data;
  },

  // Customer seed batches — Stores Supervisor queue (§j)
  getPendingSeedBatches: async (): Promise<SeedBatchDto[]> => {
    const { data } = await apiClient.get<ApiResponse<SeedBatchDto[]>>(
      "/SeedBatches/pending"
    );
    return data.data;
  },
  approveSeedBatch: async (
    id: string,
    request: SeedBatchApprovalRequest
  ): Promise<SeedBatchDto> => {
    const { data } = await apiClient.post<ApiResponse<SeedBatchDto>>(
      `/SeedBatches/${id}/approve`,
      request
    );
    return data.data;
  },
};
